import React, { useState } from "react";

import { Link } from "react-router-dom";
// TODOs interweave alternatifi gerekebilir.
import { Markup } from "interweave";
import moment from "moment";
import Bia from "./bia.json";
import { alertify } from "alertifyjs";
import { DateInput } from "semantic-ui-calendar-react";
import jurisdictions from "./jurisdictions.json";
import juriState from "./jurisdictionState.json";
import juriZero from "./jurisdictionStateZ.json";

import {
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Menu,
  Message,
  Modal,
  Pagination,
  Segment,
} from "semantic-ui-react";

const orders = [
  { key: "rel", text: "Relevance", value: "score%20desc" },
  {
    key: "newestCase",
    text: "Newest Cases First",
    value: "dateFiled%20desc",
  },
  {
    key: "oldestCase",
    text: "Oldest Cases First",
    value: "dateFiled%20asc",
  },
  {
    key: "mostCited",
    text: "Most Cited First",
    value: "citeCount%20desc",
  },
  {
    key: "leastCited",
    text: "Least Cited First",
    value: "citeCount%20asc",
  },
];

function LegalSearch() {
  const [value, setValue] = useState("");
  const [order, setOrder] = useState("dateFiled%20desc");
  const [search, setSearch] = useState([]);
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [activeItem, setItem] = useState("appellate");
  const [open, setOpen] = useState(false);
  // const [nonPrecedental, setNonPrecedental] = useState(false)
  const [bia, setBIA] = useState(true);
  const [biaArray, setBiaArray] = useState([]);
  const [activeCase, setActiveCase] = useState("fed");
  const [activeFed, setActiveFed] = useState(1);
  const [activeBia, setActiveBia] = useState(1);
  const [jurisdiction, setJurisdictions] = useState(juriState);

  const jurisdictionTrue = () => {
    const dataFed = jurisdiction.fed_app;
    const dataDist = jurisdiction.fed_dist;

    var strArr = [];

    // İki for'u tek bir for döngüsünde birleştir.
    for (const key in dataFed) {
      if (dataFed[key] === true) {
        strArr.push(key);
      }
    }

    for (const key in dataDist) {
      if (dataDist[key] === true) {
        strArr.push(key);
      }
    }

    return String(strArr.join("%20"));
  };

  const Jurisdictions = () => {
    return (
      <Modal // closeIcon
        size="huge"
        centered={false}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={
          <Form.Button fluid size="large">
            Jurisdictions (
            {jurisdictions.fed_app.length +
              jurisdictions.fed_dist.active.length +
              jurisdictions.fed_dist.terminated.length}
            )
          </Form.Button>
        }
      >
        <Modal.Header>Select Jurisdictions </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={4}>
              <Menu fluid vertical tabular>
                <Menu.Item
                  name="appellate"
                  active={activeItem === "appellate"}
                  onClick={(e, { name }) => setItem(name)}
                >
                  Federal Appellate ({jurisdictions.fed_app.length})
                </Menu.Item>
                <Menu.Item
                  name="district"
                  active={activeItem === "district"}
                  onClick={(e, { name }) => setItem(name)}
                >
                  Federal District (
                  {jurisdictions.fed_dist.active.length +
                    jurisdictions.fed_dist.terminated.length}
                  )
                </Menu.Item>
              </Menu>
            </Grid.Column>
            <Grid.Column stretched width={12}>
              <Segment>
                {activeItem === "appellate" ? (
                  <Form>
                    {" "}
                    <Button
                      color="green"
                      onClick={() =>
                        setJurisdictions({
                          ...jurisdiction,
                          fed_app: {
                            ...juriState.fed_app,
                          },
                        })
                      }
                    >
                      Check All
                    </Button>
                    <Button
                      color="red"
                      onClick={() =>
                        setJurisdictions({
                          ...jurisdiction,
                          fed_app: {
                            ...juriZero.fed_app,
                          },
                        })
                      }
                    >
                      Clear All
                    </Button>
                    <Divider />
                    <Form.Group>
                      <Grid width={4}>
                        <Grid.Column width={4}>
                          {jurisdictions.fed_app
                            .filter((item) => item.counter < 5)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_app: {
                                      ...jurisdiction.fed_app,
                                      [item.id]: !jurisdiction.fed_app[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_app[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_app
                            .filter(
                              (item) => item.counter > 4 && item.counter < 9
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_app: {
                                      ...jurisdiction.fed_app,
                                      [item.id]: !jurisdiction.fed_app[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_app[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_app
                            .filter(
                              (item) => item.counter > 8 && item.counter < 13
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_app: {
                                      ...jurisdiction.fed_app,
                                      [item.id]: !jurisdiction.fed_app[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_app[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_app
                            .filter((item) => item.counter > 12)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_app: {
                                      ...jurisdiction.fed_app,
                                      [item.id]: !jurisdiction.fed_app[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_app[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                      </Grid>
                    </Form.Group>
                  </Form>
                ) : (
                  <Form>
                    <Button
                      color="green"
                      onClick={() =>
                        setJurisdictions({
                          ...jurisdiction,
                          fed_dist: {
                            ...juriState.fed_dist,
                          },
                        })
                      }
                    >
                      Check All
                    </Button>
                    <Button
                      color="red"
                      onClick={() =>
                        setJurisdictions({
                          ...jurisdiction,
                          fed_dist: {
                            ...juriZero.fed_dist,
                          },
                        })
                      }
                    >
                      Clear All
                    </Button>
                    <Divider />
                    <Header>Active Courts</Header>{" "}
                    <Form.Group>
                      <Grid width={4}>
                        <Grid.Column width={4}>
                          {jurisdictions.fed_dist.active
                            .filter((item) => item.counter < 25)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.active
                            .filter(
                              (item) => item.counter > 24 && item.counter < 49
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.active
                            .filter(
                              (item) => item.counter > 48 && item.counter < 73
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.active
                            .filter((item) => item.counter > 72)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                      </Grid>
                    </Form.Group>
                    <Divider />
                    <Header>Terminated Courts</Header>{" "}
                    <Form.Group>
                      <Grid width={4}>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.terminated
                            .filter((item) => item.counter < 5)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.terminated
                            .filter(
                              (item) => item.counter > 4 && item.counter < 9
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.terminated
                            .filter(
                              (item) => item.counter > 8 && item.counter < 13
                            )
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          {" "}
                          {jurisdictions.fed_dist.terminated
                            .filter((item) => item.counter > 12)
                            .map((item) => (
                              <Form.Field
                                style={{ marginTop: "2px", marginRight: "2px" }}
                                label={item.text}
                                onChange={(e) =>
                                  setJurisdictions({
                                    ...jurisdiction,
                                    fed_dist: {
                                      ...jurisdiction.fed_dist,
                                      [item.id]:
                                        !jurisdiction.fed_dist[item.id],
                                    },
                                  })
                                }
                                control="input"
                                type="checkbox"
                                checked={jurisdiction.fed_dist[item.id]}
                                key={item.id}
                              />
                            ))}
                        </Grid.Column>
                      </Grid>
                    </Form.Group>
                  </Form>
                )}
              </Segment>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  };

  // ${
  //   nonPrecedental
  //     ? '&stat_Precedential=on&stat_Non-Precedential=on'
  //     : '&stat_Precedential=on'
  // }

  const handleSearch = () => {
    global
      .fetch(
        `https://www.courtlistener.com/api/rest/v3/search/?q=${value}&type=o&order_by=${order}&court=${jurisdictionTrue()}&filed_after=${first
          .trim()
          .replace(/-/g, "%2F")}&filed_before=${last
          .trim()
          .replace(/-/g, "%2F")}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token f4b67a4858cc5b87ddea4a65de106875e5aa7e59",
          },
        }
      )
      .then((res) => res.json())
      .then((data) => {
        setSearch(data);
      })
      .then(() => {
        setActiveFed(1);
      })
      .catch((err) => alertify.error(err));

    // const bia = Bia.data.filter(item =>
    //   item.description.toLowerCase().includes(value.toLowerCase())
    // )

    const sortedArray = Bia.data.sort(function (a, b) {
      if (order === "dateFiled%20desc") {
        return b.title.slice(-5, -1) - a.title.slice(-5, -1);
      }
      return a.title.slice(-5, -1) - b.title.slice(-5, -1);
    });

    const searchArray = value.trim().split(" ");

    setActiveBia(1);
    setBiaArray(
      searchArray.length === 1
        ? sortedArray.filter((item) =>
            item.text
              .toLowerCase()
              .includes(` ${searchArray[0]} `.toLowerCase())
          )
        : searchArray.length === 2
        ? sortedArray
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[0]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[1]} `.toLowerCase())
            )
        : searchArray.length === 3
        ? sortedArray
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[0]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[1]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[2]} `.toLowerCase())
            )
        : searchArray.length === 4
        ? sortedArray
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[0]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[1]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[2]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[3]} `.toLowerCase())
            )
        : searchArray.length === 5
        ? sortedArray
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[0]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[1]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[2]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[3]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[4]} `.toLowerCase())
            )
        : sortedArray
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[0]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[1]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[2]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[3]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[4]} `.toLowerCase())
            )
            .filter((item) =>
              item.text
                .toLowerCase()
                .includes(` ${searchArray[5]} `.toLowerCase())
            )
    );
  };

  // ${
  //   nonPrecedental
  //     ? '&stat_Precedential=on&stat_Non-Precedential=on'
  //     : '&stat_Precedential=on'
  // }

  const fedPagination = (e, { activePage }) => {
    global
      .fetch(
        `https://www.courtlistener.com/api/rest/v3/search/?q=${value}&type=o&order_by=${order}&court=${jurisdictionTrue()}&filed_after=${first
          .trim()
          .replace(/-/g, "%2F")}&filed_before=${last
          .trim()
          .replace(/-/g, "%2F")}&page=${activePage}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token f4b67a4858cc5b87ddea4a65de106875e5aa7e59",
          },
        }
      )
      .then((res) => res.json())
      .then((data) => setSearch(data))
      .catch((err) => alertify.error(err));

    setActiveFed(activePage);
  };

  const biaPagination = (e, { activePage }) => {
    setActiveBia(activePage);
  };

  return (
    <Grid textAlign="center" padded>
      <Grid textAlign="center" columns={2}>
        <Grid.Column width={4}>
          <Segment style={{ minHeight: "86vh" }}>
            <Form size="large">
              <Segment style={{ minHeight: "82vh" }}>
                <Button
                  as={Link}
                  to="/"
                  size="big"
                  style={{ marginRight: "10px" }}
                  fluid
                  labelPosition="left"
                  icon="left chevron"
                  content="Back"
                />
                <Message>
                  <Header>Search Criteria</Header>
                </Message>
                <Jurisdictions />
                {/* <Form.Field
                  style={{ marginTop: '2px', marginRight: '2px' }}
                  label="Add Non-Precedential Status"
                  checked={nonPrecedental}
                  onChange={e => setNonPrecedental(e.target.checked)}
                  control="input"
                  type="checkbox"
                /> */}
                <Form.Field
                  style={{ marginTop: "2px", marginRight: "2px" }}
                  label="Add Board Of Immigration Appeals"
                  checked={bia}
                  onChange={(e) => {
                    setBIA(e.target.checked);
                    setActiveCase("fed");
                  }}
                  control="input"
                  type="checkbox"
                />
                <Form.Select
                  fluid
                  label="Select Result Order"
                  onChange={(e, { value }) => setOrder(value)}
                  options={orders}
                  placeholder="Newest Cases First"
                />

                <DateInput
                  dateFormat="MM-DD-YYYY"
                  label="Filed After"
                  value={first}
                  iconPosition="left"
                  onChange={(e, { value }) => setFirst(value)}
                />

                <DateInput
                  dateFormat="MM-DD-YYYY"
                  label="Filed Before"
                  value={last}
                  iconPosition="left"
                  onChange={(e, { value }) => setLast(value)}
                />
              </Segment>
            </Form>
          </Segment>
        </Grid.Column>
        <Grid.Column width={12}>
          <Message style={{ display: "flex" }}>
            <Input
              onChange={(e) => setValue(e && e.target && e.target.value)}
              placeholder="Search..."
              size="big"
              fluid
              style={{ width: "100%" }}
            />
            <Button
              disabled={!value.trim().length}
              onClick={handleSearch}
              size="big"
            >
              SEARCH
            </Button>
          </Message>
          <Message info>
            You can use the keyword "OR" to search for individual words.
          </Message>
          <Menu attached="top" tabular>
            <Menu.Item
              name="fed"
              active={activeCase === "fed"}
              onClick={(e, { name }) => setActiveCase(name)}
            >
              Federal Appellate / District
              {search.count ? ` (${search.count} files)` : ""}
            </Menu.Item>
            {bia && (
              <Menu.Item
                name="bia"
                active={activeCase === "bia"}
                onClick={(e, { name }) => setActiveCase(name)}
              >
                Board Of Immigration Appeals
                {biaArray.length ? ` (${biaArray.length} files)` : ""}
              </Menu.Item>
            )}
          </Menu>
          <Divider />
          {activeCase === "fed" ? (
            <>
              <Segment style={{ overflow: "auto", maxHeight: "56vh" }}>
                {search.results && search.results.length !== 0 ? (
                  search.results.map((item) => (
                    <Message key={item.id}>
                      {" "}
                      <Grid stackable columns={2} centered>
                        <Grid.Column
                          width={4}
                          textAlign="center"
                          verticalAlign="middle"
                        >
                          <Message
                            vertical
                            warning
                            style={{ minHeight: "100%", textAlign: "left" }}
                          >
                            <Message.Header>Summary</Message.Header>
                            <p>
                              <b>
                                Date Filed:{" "}
                                {moment(item.dateFiled).format("MM/DD/YYYY")}
                              </b>
                            </p>
                            <p>
                              <b>Docket Number: {item.docketNumber}</b>
                            </p>
                            <p>
                              <b>Suit of Nature: {item.suitNature}</b>
                            </p>
                          </Message>
                        </Grid.Column>
                        <Grid.Column width={12}>
                          <Segment>
                            <Header>
                              {item.download_url !== null ||
                              item.download_url === "" ? (
                                <a
                                  title="Click for file"
                                  target="_blank"
                                  rel="noreferrer"
                                  href={item.download_url}
                                >
                                  {item.caseName} ({item.court}){" "}
                                  <Icon
                                    title="Downloadable PDF"
                                    name="file pdf"
                                  />
                                </a>
                              ) : (
                                <a
                                  title="Click for archive file"
                                  style={{ color: "black" }}
                                  target="_blank"
                                  rel="noreferrer"
                                  href={`https://www.courtlistener.com${item.absolute_url}`}
                                >
                                  {item.caseName} ({item.court})
                                  <Icon title="Archive File" name="archive" />
                                </a>
                              )}
                            </Header>
                            <Divider />
                            <Markup content={item.snippet} />
                          </Segment>
                        </Grid.Column>
                      </Grid>
                    </Message>
                  ))
                ) : (
                  <Message warning>
                    <Header as="h2">No Results</Header>
                  </Message>
                )}
              </Segment>
              {search.results && search.results.length > 0 && (
                <Pagination
                  size="big"
                  activePage={activeFed}
                  onPageChange={fedPagination}
                  totalPages={Math.ceil(search.count / 20)}
                />
              )}
            </>
          ) : (
            <>
              <Segment style={{ overflow: "auto", maxHeight: "56vh" }}>
                {biaArray && biaArray.length !== 0 ? (
                  biaArray
                    .slice((activeBia - 1) * 10, activeBia * 10)
                    .map((item) => (
                      <Message key={item.id}>
                        {" "}
                        <Grid stackable columns={2} centered>
                          <Grid.Column
                            width={4}
                            textAlign="center"
                            verticalAlign="middle"
                          >
                            <Message
                              vertical
                              warning
                              style={{ minHeight: "100%", textAlign: "left" }}
                            >
                              <Message.Header>Summary</Message.Header>
                              <p>
                                <b>
                                  Suit of Nature: Board Of Immigration Appeals
                                </b>
                              </p>
                            </Message>
                          </Grid.Column>
                          <Grid.Column width={12}>
                            <Segment>
                              <Header>
                                <a
                                  title="Click for file"
                                  target="_blank"
                                  rel="noreferrer"
                                  href={item.url}
                                >
                                  {item.title} ({item.id})
                                </a>
                              </Header>
                              <Divider />
                              <Markup content={item.description} />
                            </Segment>
                          </Grid.Column>
                        </Grid>
                      </Message>
                    ))
                ) : (
                  <Message warning>
                    <Header as="h2">No Results</Header>
                  </Message>
                )}
              </Segment>
              {biaArray && biaArray.length > 0 && (
                <Pagination
                  size="big"
                  activePage={activeBia}
                  onPageChange={biaPagination}
                  totalPages={Math.ceil(biaArray.length / 10)}
                />
              )}
            </>
          )}
        </Grid.Column>
      </Grid>
    </Grid>
  );
}

export default LegalSearch;
